/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'underscore';

@Pipe({
    name: 'filterByField'
})
export class FilterByFieldPipe implements PipeTransform {
    transform(items: Array<any>, field: string, toComparedValue: any): Array<any> {
        if (items) {
            return items.filter(item => item[field] == toComparedValue);
        }
        return [];
    }
}

@Pipe({
    name: 'filterOutByField'
})
export class FilterOutByFieldPipe implements PipeTransform {
    transform(items: Array<any>, field: string, toComparedValue: string): Array<any> {
        if (items) {
            return items.filter(item => item[field] != toComparedValue);
        }
        return [];
    }
}

@Pipe({
    name: 'filterOutByUserGroupType'
})
export class FilterOutByUserGroupPipe implements PipeTransform {
    transform(items: Array<any>, toComparedValue: string): Array<any> {
        return items.filter(item => {
            const code = item.userGroupDetail && item.userGroupDetail.userGroupDetailType && item.userGroupDetail.userGroupDetailType.code ? item.userGroupDetail.userGroupDetailType.code : '';
            return code != toComparedValue
        });
    }
}

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) return [];
        if (!searchText) return items;
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            return it.toString().toLowerCase().includes(searchText);
        });
    }
}


@Pipe({
    name: 'filterByArray'
})
export class FilterByArrayPipe implements PipeTransform {
    transform(items: Array<any>, inputArray: Array<any>, fieldNameToMap: string): Array<any> {
        const fullMappedFieldNameArray = _.pluck(items, fieldNameToMap);
        const inputMappedFieldNameArray = _.pluck(inputArray, fieldNameToMap);
        const finalDifrenceMappedFieldName = _.difference(fullMappedFieldNameArray, inputMappedFieldNameArray);
        return items.filter(rec => _.contains(finalDifrenceMappedFieldName, rec[fieldNameToMap]));
    }
}

@Pipe({
    name: 'filterOutByProgramCode'
})
export class FilterOutByProgramCode implements PipeTransform {
    transform(items: Array<any>, toComparedValue: any): Array<any> {
        return items.filter(item => {
            if (toComparedValue) {
                const code = item && item.programCode;
                return code == toComparedValue
            } else {
                return true;
            }
        });
    }
}
